import { startTransition, StrictMode, Fragment } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

// Initialize Sentry before anything else
import { initSentry } from "@/utils/sentry";
import "@xyflow/react/dist/style.css";
import {
  clearChunkReloadAttemptFlag,
  isChunkLoadError,
  reloadOnceForStaleChunks,
} from "@/utils/chunkLoadError";
import { logAniOsChunkLoadError } from "@/utils/aniosDiagnostics";

initSentry();
clearChunkReloadAttemptFlag();

if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    if (!isChunkLoadError(event.reason)) return;
    event.preventDefault();
    logAniOsChunkLoadError("unhandledrejection", event.reason);
    reloadOnceForStaleChunks({ source: "unhandledrejection" });
  });
}

// Allow disabling StrictMode for performance profiling via VITE_DISABLE_STRICT_MODE=true
const StrictModeWrapper = import.meta.env.VITE_DISABLE_STRICT_MODE
  ? Fragment
  : StrictMode;

startTransition(() => {
  hydrateRoot(
    document,
    <StrictModeWrapper>
      <HydratedRouter />
    </StrictModeWrapper>
  );
});
